// Import mutations
import { GET_PRESENCES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_PRESENCES] (state, presences) {
    state.all = presences
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/presences.js